import React from "react";
import { Routes, Route } from "react-router-dom";

import HomePage from "../pages/HomePage";
import UserLoginPage from "../pages/UserLoginPage";

import CarsForSale from "../components/cars/CarForrent";
import CarsForRent from "../components/cars/CarsForsale";
import DashboardPage from "../pages/DashboardPage";
import TripReport from "../components/cars/TripReport";
import PrivacyPolicy  from "../components/cars/PrivacyPolicy";
import RefundPolicy  from "../components/cars/RefundPolicy";
import ContactUs from "../components/home/ContactUs";
import AboutUs from "../components/home/AboutUs";


function AppRoute() {
  return (
    <Routes>
      
      {/* Home */}
      <Route
        path="/"
        element={<HomePage />}
      />

      {/* Login */}
      <Route
        path="/login"
        element={<UserLoginPage />}
      />

      {/* Cars for Sale */}
      <Route
        path="/cars-for-sale"
        element={<CarsForSale />}
      />

      {/* Cars for Rent */}
      <Route
        path="/cars-for-rent"
        element={<CarsForRent />}
      />

       <Route
        path="/dashboard"
        element={<DashboardPage/>}
      />

       <Route
        path="/TripReport"
        element={<TripReport/>}
      />

      <Route
    path="/privacy-policy"
    element={<PrivacyPolicy />}
/>

<Route
    path="/refund-policy"
    element={<RefundPolicy />}
/>
<Route
    path="/contact-us"
    element={<ContactUs />}
/>

<Route path="/about-us" 
 element={<AboutUs />} />
    </Routes>
  );
}

export default AppRoute;